import { isDefined } from '@sgme/fp';
import type { QuoteInfo } from 'apiConnector/scheduledRun/model';
import type { DynamicFormInfos } from 'state/dynamic/infos/infos.model';
import { getTradeInfos } from 'state/quotes/trades/trades.selectors';
import {
  getFormInfos,
  getFormQuoteDetails,
  getFormQuoteId,
  getFormQuoteResult,
  getUserPriceEnhancementByQuoteId,
  getUserSponsoFeesByQuoteId,
} from 'state/selectors';
import type { AppState } from 'state/state.model';
import * as fromTradeConfirmation from 'state/uiPanelState/tradeConfirmation/tradeConfirm.selectors';
import type { QuoteWorkspaceType } from 'state/workspaces/model';
import { isExternalQuoteId } from 'utils/string';

export function getQuoteExternalIdByWorkspaceTab(state: AppState, workspace: QuoteWorkspaceType, tabId: string) {
  const quoteId = getFormQuoteId(state, workspace, tabId);
  return (
    getFormQuoteResult(state, workspace, tabId)?.quoteExternalId ??
    getFormQuoteDetails(state, workspace, tabId)?.QuoteExternalId ??
    (isDefined(quoteId) && isExternalQuoteId(quoteId) ? quoteId : undefined)
  );
}

export function getQuoteInfoByWorkspaceTab(
  state: AppState,
  workspace: QuoteWorkspaceType,
  tabId: string,
): QuoteInfo | undefined {
  const details = getFormQuoteDetails(state, workspace, tabId);
  const result = getFormQuoteResult(state, workspace, tabId);
  const info = getFormInfos(state, workspace, tabId) as DynamicFormInfos;
  if (!isDefined(details)) {
    return undefined;
  }
  return {
    quoteId: details.QuoteExternalId ?? result?.quoteExternalId,
    productSubType: info.instrumentContractName ?? details.ProductSubtype ?? undefined,
    productType: info.instrumentName ?? details.ProductType ?? undefined,
  };
}

export function getTradeConfirmationByQuoteId(state: AppState, quoteId: string | undefined) {
  return fromTradeConfirmation.getTradeConfirmation(state.uiPanel.tradeConfirmations, quoteId);
}
export function getTradeInfosByWorkspaceTab(state: AppState, workspace: QuoteWorkspaceType, tabId: string) {
  const quoteId = getFormQuoteId(state, workspace, tabId);
  return getTradeInfos(state.quotes.trades, quoteId);
}
export function getUserPriceEnhancement(state: AppState, workspace: QuoteWorkspaceType, tabId: string) {
  const quoteId = getFormQuoteId(state, workspace, tabId);
  return getUserPriceEnhancementByQuoteId(state, quoteId);
}
export function getUserSponsoFees(state: AppState, workspace: QuoteWorkspaceType, tabId: string) {
  const quoteId = getFormQuoteId(state, workspace, tabId);
  return getUserSponsoFeesByQuoteId(state, quoteId);
}
